export const DEFAULT_RECORDS_LIMIT = 20000;
